import React, { useState, useEffect } from 'react';
import google from '../../images/google.png';
import apple from '../../images/apple.png';

function Complete() {
  return (
    <>
      <div className="flex justify-center">
        <div className="w-full md:w-7/12 my-5 px-3 md:my-20">
          <div className="text-lg">
            <div className="text-xl lgg:text-4xl font-semibold text-portal-600 py-2 md:py-4 ">
              Thank You for Completing Onboarding!
            </div>
            <div className=" font-light text-md lgg:text-xl py-2">
              Please allow 24-48 hours for us to setup your provider account.
            </div>
            <div className="font-semibold pb-1 text-md lgg:text-xl py-2 md:py-4">
              In the meantime, download our Provider App below.
            </div>
            <div className="flex my-2 md:my-5">
              <img src={apple} className="w-2/5 md:w-1/4 mr-4" />
              <img src={google} className="w-2/5 md:w-1/4" />
            </div>
            <div className="font-light pb-1 text-md lgg:text-xl py-2 md:py-4">
              When we’re done setting up your account, we will notify you via text and you’ll be able to log in to the app.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Complete;
